import { render } from "./ProductosView.vue?vue&type=template&id=b59401d2&ts=true"
import script from "./ProductosView.vue?vue&type=script&lang=ts"
export * from "./ProductosView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__